import React from "react";
import ProjectsList from "./ProjectsList";
import Teams from "./Teams";

const Sidebar = () => {
  return (
    <>
      <div className="sidebar">
        <ProjectsList />
        <Teams />
      </div>
    </>
  );
};

export default Sidebar;
